import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'
import { appendAlert } from '@/plugins/alert';
import { v4 as uuidv4 } from 'uuid';

export class TransfersService extends BaseService {
  static get entity () {
    return 'v1/transfers'
  }

  static async send(params) {     
    params.guid = uuidv4();   

    try {
      const response = await this.request({ auth: true }).post(`${this.entity}`, params)
      appendAlert("Данные для перевода успешно сохранены", 'success');
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data : error.response.statusText
      if (message === "error: incorrect deal") {
        appendAlert("Произошла ошибка при сохранении данных для перевода. Между сторонами нет взаиморасчетов", 'danger');                
      } else if ( message === "error: incorrect request") {
        appendAlert("Произошла ошибка при сохранении данных для перевода. Некорректные параметры создания перевода", 'danger');  
      } else {
        throw new ErrorWrapper(error, message)
      }
    }
  }

  static async getByGUID(guid) {      
    try {
      const response = await this.request({ auth: true }).get(`${this.entity}/${guid}`)
      console.log(response)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getList(limit, offset) {      
    try {
      const response = await this.request({ auth: true }).get(`${this.entity}?limit=${limit}&offset=${offset}`)
      console.log(response)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async delete(guid) {      
    try {
      const response = await this.request({ auth: true }).delete(`${this.entity}/${guid}`)      
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      appendAlert("Произошла ошибка при удалении документа", 'danger');
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async update(guid, params) {     
    params.guid = guid;

    try {
      const response = await this.request({ auth: true }).put(`${this.entity}/${guid}`, params)
      appendAlert("Документ сохранен", 'success');
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      appendAlert("Произошла ошибка при сохранении документа", 'danger');
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
}
